if (!window.vhQtyInit) {
window.vhQtyInit = true;
  let urlParams = new URLSearchParams(window.location.search);
  let flavor = urlParams.get('flavor');
  if(flavor){
      flavor = flavor.trim();
      flavor = flavor.slice(0,1).toLocaleUpperCase() + flavor.slice(1);
  }
  window.total_selected_product_qty = 0;  // Global total selected product quantity variable  
  window.initial_selected_product_qty = 0; // Global initial_selected_product_qty variable 
  window.selected_product_value = 39.96; // Global selected_product_value variable 
  window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 0,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 0,
          "Birthday Cake": 0,
          "Pina Colada": 0,
          "Salted Caramel": 0
      }; 
       // Global selected_product_qty_details object which is globally accessible 

  if(flavor){
    let updated_flavor = flavor.toLowerCase();
    if(updated_flavor.includes('cook')){
        updated_flavor = "Cookies & Cream"
        window.selected_product_qty_details = 
        {
            "Chocolate": 0,
            "Vanilla": 0,
            "Strawberry": 0,
            "Cookies & Cream": 0,
            "Café Latte": 0,
            "Chocolate PB Banana": 0,
            "Blueberry Cobbler": 0,
            "Peanut Butter & Jelly": 0,
            "Cinnamon Roll": 0,
            "Double Chocolate": 0,
            "Vanilla Ice Cream": 0,
            "Dubai Chocolate": 0,
            "Birthday Cake": 0,
            "Pina Colada": 0,
            "Salted Caramel": 0,
            [updated_flavor]: 1
        };
    }
    else if(updated_flavor.includes('coffee')){
        updated_flavor = "Café Latte"
        window.selected_product_qty_details = 
        {
            "Chocolate": 0,
            "Vanilla": 0,
            "Strawberry": 0,
            "Cookies & Cream": 0,
            "Café Latte": 0,
            "Chocolate PB Banana": 0,
            "Blueberry Cobbler": 0,
            "Peanut Butter & Jelly": 0,
            "Cinnamon Roll": 0,
            "Double Chocolate": 0,
            "Vanilla Ice Cream": 0,
            "Dubai Chocolate": 0,
            "Birthday Cake": 0,
            "Pina Colada": 0,
            "Salted Caramel": 0,
            [updated_flavor]: 1
        };
    }
    else if(updated_flavor.includes('blueberry')){
        window.selected_product_qty_details = 
        {
            "Chocolate": 0,
            "Vanilla": 0,
            "Strawberry": 0,
            "Cookies & Cream": 0,
            "Café Latte": 0,
            "Chocolate PB Banana": 0,
            "Blueberry Cobbler": 1,
            "Peanut Butter & Jelly": 0,
            "Cinnamon Roll": 0,
            "Double Chocolate": 0,
            "Vanilla Ice Cream": 0,
            "Dubai Chocolate": 0,
            "Birthday Cake": 0,
            "Pina Colada": 0,
            "Salted Caramel": 0
        };
    }
    else if(updated_flavor.includes('pbj')){
        window.selected_product_qty_details = 
        {
            "Chocolate": 0,
            "Vanilla": 0,
            "Strawberry": 0,
            "Cookies & Cream": 0,
            "Café Latte": 0,
            "Chocolate PB Banana": 0,
            "Blueberry Cobbler": 0,
            "Peanut Butter & Jelly": 1,
            "Cinnamon Roll": 0,
            "Double Chocolate": 0,
            "Vanilla Ice Cream": 0,
            "Dubai Chocolate": 0,
            "Birthday Cake": 0,
            "Pina Colada": 0,
            "Salted Caramel": 0

        };
    }
    else if(updated_flavor.includes('cinnamon')){
      window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 1,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 0,
          "Birthday Cake": 0,
          "Pina Colada": 0,
          "Salted Caramel": 0

      };
    }
    else if(updated_flavor.includes('dubai')){
      window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 0,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 1,
          "Birthday Cake": 0,
          "Pina Colada": 0,
          "Salted Caramel": 0

      };
    }
    else if(updated_flavor.includes('birthday')){
      window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 0,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 0,
          "Birthday Cake": 1,
          "Pina Colada": 0,
          "Salted Caramel": 0

      };
    }
    else if(updated_flavor.includes('pina')){
      window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 0,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 0,
          "Birthday Cake": 0,
          "Pina Colada": 1,
          "Salted Caramel": 0

      };
    }

    else if(updated_flavor.includes('caramel')){
      window.selected_product_qty_details = 
      {
          "Chocolate": 0,
          "Vanilla": 0,
          "Strawberry": 0,
          "Cookies & Cream": 0,
          "Café Latte": 0,
          "Chocolate PB Banana": 0,
          "Blueberry Cobbler": 0,
          "Peanut Butter & Jelly": 0,
          "Cinnamon Roll": 0,
          "Double Chocolate": 0,
          "Vanilla Ice Cream": 0,
          "Dubai Chocolate": 0,
          "Birthday Cake": 0,
          "Pina Colada": 0,
          "Salted Caramel": 1

      };
    }
    else{
        updated_flavor = flavor.charAt(0).toUpperCase() + flavor.slice(1);
        if(updated_flavor.includes('banana') || updated_flavor.includes('Banana')){
           updated_flavor = "Chocolate PB Banana";
        }
        if(window.selected_product_qty_details[updated_flavor]==0 || window.selected_product_qty_details[updated_flavor]){
          window.selected_product_qty_details = 
          {
              "Chocolate": 0,
              "Vanilla": 0,
              "Strawberry": 0,
              "Cookies & Cream": 0,
              "Café Latte": 0,
              "Chocolate PB Banana": 0,
              "Blueberry Cobbler": 0,
              "Peanut Butter & Jelly": 0,
              "Cinnamon Roll": 0,
              "Double Chocolate": 0,
              "Vanilla Ice Cream": 0,
              "Dubai Chocolate": 0,
              "Birthday Cake": 0,
              "Pina Colada": 0,
              "Salted Caramel": 0,
              [updated_flavor]: 1
          };
        }
        else{
          window.selected_product_qty_details = 
          {
              "Chocolate": 0,
              "Vanilla": 0,
              "Strawberry": 0,
              "Cookies & Cream": 0,
              "Café Latte": 0,
              "Chocolate PB Banana": 0,
              "Blueberry Cobbler": 0,
              "Peanut Butter & Jelly": 0,
              "Cinnamon Roll": 0,
              "Double Chocolate": 0,
              "Vanilla Ice Cream": 0,
              "Dubai Chocolate": 0,
              "Birthday Cake": 0,
              "Salted Caramel": 0,
              "Pina Colada": 1
          };
        }
    }

  }
  else{
    if(window.location.pathname.includes("one-max-superfood-protein-creatine") || window.location.pathname.includes("/products_preview")){
          window.selected_product_qty_details = 
          {
              "Chocolate": 0,
              "Vanilla": 0,
              "Strawberry": 0,
              "Cookies & Cream": 0,
              "Café Latte": 0,
              "Chocolate PB Banana": 0,
              "Blueberry Cobbler": 0,
              "Peanut Butter & Jelly": 0,
              "Cinnamon Roll": 0,
              "Double Chocolate": 0,
              "Vanilla Ice Cream": 1
          };
    }
    //   window.selected_product_qty_details['Strawberry'] = 1;
      // window.selected_product_qty_details = 
      // {
      //     "Chocolate": 0,
      //     "Vanilla": 0,
      //     "Strawberry": 1,
      //     "Cookies & Cream": 0,
      //     "Café Latte": 0,
      //     "Chocolate PB Banana": 0
      // };
  }

   function vhProgressBarReady(event) {
    if (!window.jQuery) {
      setTimeout(function () { vhProgressBarReady(event); }, 50);
      return;
    }
    var $ = window.jQuery;

    $(document).on('click', '[data-cart-checkout-button]', function(){
      window.location.href = "/checkout"
    })

      var SuperfoodCount = 0;
      var count = 0;
      var total_Superfood_productCount = 0;
      var IgLoaded = false;
      initialCheckfreeshipping();



      function initialCheckfreeshipping(){

        $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false,
          dataType: 'json',
          success: function(cart) {
              let maxPdp = false;
              total_SuperfoodCount = cart.items.reduce(function(total, item) {
                if(item.title.includes('Creatine') &&  window.max_free_shaker_promotion == 'true'){
                    maxPdp = true;
                  }
                  return (item.grams*item.quantity*0.00220462);
              }, 0);
              window.total_SuperfoodCount = total_SuperfoodCount;
              total_Superfood_productCount = total_SuperfoodCount;
              let cartTotal =  parseFloat(cart.total_price)/100;
              let pathName = window.location.pathname;
              let basePrice = 39.96;
              if(pathName.includes('products/one-superfood-protein-greens-59')){
                basePrice = 49.95
              }
              if(pathName.includes('products/one-superfood-protein-greens-1')){
                basePrice = 44.95
              }
              if(pathName.includes('products/one-superfood-protein-coffee')){
                basePrice = 39.96;
              }
              if(pathName.includes('products/one-superfood-protein-greens-4') || pathName.includes('products/one-superfood-protein-greens-5')){
                basePrice = 39.96;
              }
              if (pathName.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale) {
                basePrice = 44.77;
              }
              if(pathName.includes('products/one-max-superfood-protein-creatine') || pathName.includes('products_preview')){
                basePrice = 55.96;
              }
               if(pathName.includes('products/one-max-superfood-protein-creatine') && window.bmcf == "true"){
                  basePrice = 41.97;
               }
              if(pathName.includes('products/one-superfood-protein-shake-strawberry-dtc')){
                basePrice = 39.96;
              }
              if(pathName.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale){
                basePrice = 31.97;
              }
              if(pathName.includes('products/one-superfood-protein-shake-strawberry') && window.bmcf == "true"){
                basePrice = 29.97;
              }
              if(pathName.includes('products/one-superfood-protein-shake-strawberry-9')){
                basePrice = 44.96;
              } 
              else if(pathName.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="false"){
                basePrice = 39.96;
              }  
              total_selected_product_qty = basePrice + cartTotal;
              initial_selected_product_qty = cartTotal;

              let total_superfood_weight = 0;
              $('.flavor_with_quantity').each(function(){
                  let val = $(this).find('.select_product_quantity select').val();
                  if(val>=1){
                      let weight = $(this).attr('weight');
                      total_superfood_weight = total_superfood_weight + (weight*val*0.00220462); 
                  }
              });
              let total_cart_weight = window.total_SuperfoodCount + total_superfood_weight;
              window.updateFreeShpping(total_cart_weight,null, total_selected_product_qty, maxPdp);

            // whatever you want to do with the cart obj
          }
      });
      }
      
      // call checkfreeshipping function to check progress bar status on onload
      // initialCheckfreeshipping();

      // update progess bar status, add to cart button while selecting quanity on strawberry PDP 
      var igTotalQty = 0;
      var igSubMultiplier = 1;
      let subscriptionDiscountnew = 20;
      if(window.location.pathname.includes('products/one-superfood-protein-greens-59')){
        subscriptionDiscountnew = 16.68;
      }
      else if(window.location.pathname.includes('products/one-superfood-protein-greens-1')){
        subscriptionDiscountnew = 25;
      }
      else if(window.location.pathname.includes('products/one-superfood-protein-greens-4') || window.location.pathname.includes('products/one-superfood-protein-greens-5')){
        subscriptionDiscountnew = 27.28;
      }
      else if (window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale == "true") {
        subscriptionDiscountnew = 36;
      }
      else if (window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.bfcm == "true") {
        subscriptionDiscountnew = 40;
      }
      else if(window.location.pathname.includes('products/one-max-superfood-protein-creatine') || window.location.pathname.includes('products_preview')){
        subscriptionDiscountnew = 20;
      }
      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry-dtc')){
        subscriptionDiscountnew = 20;
      }
      else if(window.location.pathname.includes('products/one-superfood-protein-coffee')){
        subscriptionDiscountnew = 18;
      }
      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="true"){
        subscriptionDiscountnew = 36;
      }

      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry-9')){
        subscriptionDiscountnew = 25;

      }
     
      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.bfcm == "true" ){
        
        subscriptionDiscountnew = 45.46;
      }

      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry')){
        subscriptionDiscountnew = 20;

      }
      else if(window.location.pathname.includes('products/all-in-one-nutrition-bundle')){
        subscriptionDiscountnew = 59.21;
      }
      $(document).off('change.vhQty').on('change.vhQty', '.select_product_quantity select', function(){
          igTotalQty = 0;
          var featuredRoot = $(this).closest('.featured-product-custom');
          if (featuredRoot.length && window.selected_product_qty_details) {
            featuredRoot.find('.select_product_quantity select').each(function () {
              var flavorName = $(this).attr('flavor');
              if (flavorName) window.selected_product_qty_details[flavorName] = $(this).val();
            });
          }
          let value = $(this).attr('data-value');
          let flavor = $(this).attr('flavor');
          
          let purchase_type = (featuredRoot.length ? featuredRoot : $(document)).find('input[name^="subscribe"]:checked').val();
          let discounted_price = $(this).attr('discounted_price');

          if(purchase_type=="onetime_plan" && window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="true"){
            subscriptionDiscountnew = 20;
          }
          else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="true" && purchase_type=="selling_plan"){
            subscriptionDiscountnew = 36;
          }

          else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.bmcf == "true" && purchase_type=="selling_plan"){
            subscriptionDiscountnew = 46;
          }

          if (purchase_type == "onetime_plan" && window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale == "true") {
            subscriptionDiscountnew = 20;
          }
          else if (window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale == "true" && purchase_type == "selling_plan") {
            subscriptionDiscountnew = 36;
          }

          else if (window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.bmcf == "true" && purchase_type == "selling_plan") {
            subscriptionDiscountnew = 40;
          }

          let qty = $(this).val();
          let oldqty = selected_product_qty_details[flavor];
          selected_product_qty_details[flavor] = qty;

          let tempTotal = 0,temptotal2 = 0;
          let defaultVariantId = $('.discounted_price_box span.discounted_price').attr('data-variant-id');
          var {subscriptionDiscount = 20, subscriptionDiscountType = 'percentage'} = window?.igData?.price?.getSubscriptionDiscountByVariantId(defaultVariantId) || {};
          subscriptionDiscount = subscriptionDiscountnew;
          igSubMultiplier = subscriptionDiscount = parseFloat(1-(subscriptionDiscount/100));
          let temptotalValue = Object.keys(selected_product_qty_details).map((item,i)=>{
              if (featuredRoot.length) {
                var qtyItem = Number(selected_product_qty_details[item]) || 0;
                if (!qtyItem) return;
                var flavorSelect = featuredRoot.find('.select_product_quantity select').filter(function () {
                  return $(this).attr('flavor') === item;
                });
                var listPrice = parseFloat(flavorSelect.attr('data-value')) || parseFloat(value) || 0;
                var subPrice = parseFloat(flavorSelect.attr('discounted_price')) || parseFloat(discounted_price) || listPrice;
                if (purchase_type == "selling_plan") {
                  tempTotal = tempTotal + qtyItem * subPrice;
                  temptotal2 = temptotal2 + qtyItem * listPrice;
                } else {
                  tempTotal = tempTotal + qtyItem * listPrice;
                  temptotal2 = temptotal2 + qtyItem * listPrice;
                }
                igTotalQty = igTotalQty + qtyItem;
                return;
              }
              if(defaultVariantId){
                if(purchase_type=="selling_plan"){
                    var igProductPrice = parseFloat(window.igData?.price?.getPriceByVariantId(defaultVariantId)) || value;
                    subscriptionDiscount = window.bfcm == 'true' ? ( 1 - subscriptionDiscountnew * 0.01 ) : subscriptionDiscount;
                    tempTotal = tempTotal + igProductPrice*subscriptionDiscount*selected_product_qty_details[item];
                    temptotal2 = temptotal2 + selected_product_qty_details[item]*igProductPrice;
                    igTotalQty = igTotalQty + parseInt(selected_product_qty_details[item]);
                  }
                  else{
                      // tempTotal = tempTotal + igProductPrice*subscriptionDiscount*selected_product_qty_details[item];
                      // temptotal2 = temptotal2 + selected_product_qty_details[item]*igProductPrice;
                      // igTotalQty = igTotalQty + parseInt(selected_product_qty_details[item]);
                      if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="true"){
                        tempTotal = tempTotal + selected_product_qty_details[item]*value*0.8;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                      }
                      else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.bfcm=="true"){
                        let tempHold = selected_product_qty_details[item]*value*0.7503;
                        let selNum = Math.floor(tempHold * 100) / 100;
                        tempTotal = tempTotal +  selNum;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                      }
                      else if(window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale=="true"){
                        tempTotal = tempTotal + selected_product_qty_details[item]*value*0.8;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                      }
                      else if(window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.bfcm=="true"){
                        let tempHold = selected_product_qty_details[item]*value*0.75025;
                        let selNum = Math.floor(tempHold * 100) / 100;
                        tempTotal = tempTotal + selNum;
                    
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                      }
                      else{
                        tempTotal = tempTotal + selected_product_qty_details[item]*value;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value

                      }
                  }
              }
              else{

                  if(purchase_type=="selling_plan"){
                      tempTotal = tempTotal + selected_product_qty_details[item]*discounted_price*1;
                      temptotal2 = temptotal2 + selected_product_qty_details[item]*value
                  }
                  else{
                    if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.memorial_day_sale=="true"){
                      tempTotal = tempTotal + selected_product_qty_details[item]*discounted_price*0.8;
                      temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1
                    }
                    else if(window.location.pathname.includes('products/one-superfood-protein-shake-strawberry') && window.bfcm=="true"){
                      let tempHold = selected_product_qty_details[item]*value*0.7503;
                      let selNum = Math.floor(tempHold * 100) / 100;
                      tempTotal = tempTotal + selNum;
                      temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1
                    }
                    else if(window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.memorial_day_sale=="true"){
                        tempTotal = tempTotal + selected_product_qty_details[item]*value*0.8;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                    }
                    else if(window.location.pathname.includes('products/one-max-superfood-protein-creatine') && window.bfcm=="true"){
                        let tempHold = selected_product_qty_details[item]*value*0.75025;
                        let selNum = Math.floor(tempHold * 100) / 100;
                        tempTotal = tempTotal + selNum;
                        temptotal2 = temptotal2 + selected_product_qty_details[item]*value*1;
                    }
                    else{
                      tempTotal = tempTotal + selected_product_qty_details[item]*discounted_price*1;
                      temptotal2 = temptotal2 + selected_product_qty_details[item]*value
                      // tempTotal = tempTotal + selected_product_qty_details[item]*value;
                      // temptotal2 = temptotal2 + selected_product_qty_details[item]*value
                      
                    }
                      // tempTotal = tempTotal + selected_product_qty_details[item]*value;
                      // temptotal2 = temptotal2 + selected_product_qty_details[item]*value
                  }
              }
          })

        //   total_selected_product_qty = initial_selected_product_qty + tempTotal;
          total_selected_product_qty = tempTotal;
          selected_product_value = (tempTotal).toFixed(2);
          if(temptotal2 > 0){
            $('.add_to_cart_button').removeClass('disable');
          }
          
          let temp_total_price = temptotal2;
          let total_price = temp_total_price.toFixed(2);
          let temp_saving_price = total_price - selected_product_value;
          let saving_price = temp_saving_price.toFixed(2);
          igSubMultiplier = igSubMultiplier * igTotalQty;
          $('.add_to_cart_saving_text .price_conatiner .price').text(`$${selected_product_value}`);
          $('.add_to_cart_saving_text .price_conatiner .total_price').text(`$${selected_product_value}`);
          $('.add_to_cart_saving_text .price_conatiner .pricenew').text(`$${selected_product_value}`);
          $('.add_to_cart_saving_text .price_conatiner .total_pricev2').text(`$${selected_product_value}`);
          $('.add_to_cart_saving_text .price_conatiner del').text(`$${total_price }`);
          $('.add_to_cart_saving_text .price_conatiner .price').attr('data-price-multiplier',igSubMultiplier);
          $('.add_to_cart_saving_text .price_conatiner del').attr('data-price-multiplier',igTotalQty);
          $('.add_to_cart_saving_text .saving_text p span').text(`${saving_price }`);
          $('.add_to_cart_saving_text .saving_text p em.saving_amount2').text(`${saving_price }`);
          $('.add_to_cart_saving_text .saving_text p em.saving_amountv2').text(`${saving_price}`);

          if (featuredRoot.length) {
            var liveQty = 0;
            featuredRoot.find('.select_product_quantity select').each(function () {
              liveQty += Number($(this).val()) || 0;
            });
            if(selected_product_value == 0 && liveQty === 0){
                featuredRoot.find('.add_to_cart_button').addClass('disable');
                featuredRoot.find('.add_to_cart_saving_text .saving_text').css('display','none');
            }
            else{
                if(window.igData){
                    if(purchase_type=="selling_plan"){
                      featuredRoot.find('.add_to_cart_saving_text .saving_text').css('display','flex');
                      featuredRoot.find('.add_to_cart_button').removeClass('disable');
                    }
                }
                if (liveQty > 0) {
                  featuredRoot.find('.add_to_cart_button').removeClass('disable');
                }
            }
          }
          else if(selected_product_value == 0){
              $('.add_to_cart_button').addClass('disable');
              $('.add_to_cart_saving_text .saving_text').css('display','none');
          }
          else{
              if(window.igData){
                  if(purchase_type=="selling_plan"){
                    $('.add_to_cart_saving_text .saving_text').css('display','flex');
                    $('.add_to_cart_button').removeClass('disable');
                  }
              }
          }


          // }
        let total_superfood_weight = 0;
        $('.flavor_with_quantity').each(function(){
            let val = $(this).find('.select_product_quantity select').val();
            if(val>=1){
                let weight = $(this).attr('weight');
                total_superfood_weight = total_superfood_weight + (weight*val*0.00220462); 
            }
        });
        let total_cart_weight = window.total_SuperfoodCount + total_superfood_weight;
        window.updateFreeShpping(total_cart_weight,null,total_selected_product_qty);
      })
      var presetQty = $('.featured-product-custom .select_product_quantity select').filter(function () {
        return Number(this.value) > 0;
      }).first();
      if (presetQty.length) presetQty.trigger('change');
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", vhProgressBarReady);
  } else {
    vhProgressBarReady();
  }
}
 